module.exports = __webpack_public_path__ + "15c6521b421d62d6617399ed008dc903.svg";